import { Currency } from './types';

export interface StripeProduct {
  id: string;
  priceIds: Record<Currency, string>;
  name: string;
  description: string;
  mode: 'payment' | 'subscription';
  tokens: number;
  prices: Record<Currency, number>;
  isPopular?: boolean;
  translationKey: string;
}

export const STRIPE_PRODUCTS: StripeProduct[] = [
  {
    id: 'prod_VQGFbdUXUCBEqx',
    priceIds: {
      [Currency.MXN]: 'price_1UPPiqIhdoYIvoO8rubBqQhi',
      [Currency.USD]: 'price_1UPPiqIhdoYIvoO8rubBqQhi',
      [Currency.EUR]: 'price_1UPPiqIhdoYIvoO8rubBqQhi',
    },
    name: 'Test Plan',
    description: 'Test Plan with 1 quotation credit',
    mode: 'payment',
    tokens: 1,
    prices: {
      [Currency.MXN]: 99,
      [Currency.USD]: 99,
      [Currency.EUR]: 99,
    },
    translationKey: 'test_1'
  },
  {
    id: 'prod_VQGGhZ3aQQkHpp',
    priceIds: {
      [Currency.MXN]: 'price_1UPPkNIhdoYIvoO8FNBk48xh',
      [Currency.USD]: 'price_1UPPkNIhdoYIvoO8FNBk48xh',
      [Currency.EUR]: 'price_1UPPkNIhdoYIvoO8FNBk48xh',
    },
    name: 'Basic Plan',
    description: 'Basic Plan with 10 quotation credits',
    mode: 'payment',
    tokens: 10,
    prices: {
      [Currency.MXN]: 549,
      [Currency.USD]: 549,
      [Currency.EUR]: 549,
    },
    translationKey: 'basic_10'
  },
  {
    id: 'prod_VQGIP05Mz5CQ1G',
    priceIds: {
      [Currency.MXN]: 'price_1UPPloIhdoYIvoO8vLlW9DK1',
      [Currency.USD]: 'price_1UPPloIhdoYIvoO8vLlW9DK1',
      [Currency.EUR]: 'price_1UPPloIhdoYIvoO8vLlW9DK1',
    },
    name: 'Pro Plan',
    description: 'Pro Plan with 20 quotation credits',
    mode: 'payment',
    tokens: 20,
    prices: {
      [Currency.MXN]: 919,
      [Currency.USD]: 919,
      [Currency.EUR]: 919,
    },
    translationKey: 'pro_20'
  },
  {
    id: 'prod_VQGQc1623ymQgL',
    priceIds: {
      [Currency.MXN]: 'price_1UPPtGIhdoYIvoO8vXZkRwBV',
      [Currency.USD]: 'price_1UPPtGIhdoYIvoO8vXZkRwBV',
      [Currency.EUR]: 'price_1UPPtGIhdoYIvoO8vXZkRwBV',
    },
    name: 'Premium Plan',
    description: 'Premium Plan with 50 quotation credits',
    mode: 'payment',
    tokens: 50,
    prices: {
      [Currency.MXN]: 2049,
      [Currency.USD]: 2049,
      [Currency.EUR]: 2049,
    },
    isPopular: true,
    translationKey: 'premium_50'
  }
];

export const getProductByPriceId = (priceId: string): StripeProduct | undefined => {
  return STRIPE_PRODUCTS.find(product =>
    Object.values(product.priceIds).includes(priceId)
  );
};

export const getProductById = (id: string): StripeProduct | undefined => {
  return STRIPE_PRODUCTS.find(product => product.id === id);
};

export const getPriceIdForCurrency = (productId: string, currency: Currency): string | undefined => {
  const product = getProductById(productId);
  return product?.priceIds[currency];
};

export const getPriceForCurrency = (productId: string, currency: Currency): number | undefined => {
  const product = getProductById(productId);
  return product?.prices[currency];
};
